import React from 'react';
import { GitFork, FolderKanban, Waves, Users, Building2 } from 'lucide-react';
import GenericIndicator from './GenericIndicator';

const ICON_MAP = {
  repository: GitFork,
  project: FolderKanban,
  stream: Waves,
  member: Users,
  org: Building2,
};

export default function ScopeChangeIndicator({ scope, reduceMotion }: any) {
  const Icon = ICON_MAP[scope?.kind] || Building2;
  const label = scope?.label;
  if (!label) return null;

  return (
    <GenericIndicator
      icon={Icon}
      label={`Context: ${label}`}
      variant="purple"
      reduceMotion={reduceMotion}
    />
  );
}
